import clsx from "clsx";

export const RESOURCE_CARD_CLASSES = {
  container: clsx(
    "bg-white rounded-lg border border-raro-gray-200 shadow-raro overflow-hidden"
  ),
  header: clsx("p-3 border-b border-raro-gray-200 bg-raro-gray-50"),
  title: clsx("text-base font-medium text-raro-gray-900 font-montserrat"),
  totalBadge: clsx(
    "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium font-montserrat",
    "bg-primary-100 text-primary-800"
  ),
  grid: clsx("grid grid-cols-3 divide-x divide-raro-gray-200"),
  section: clsx("p-3"),
  sectionTitle: clsx(
    "text-xs font-medium text-raro-gray-500 uppercase tracking-wider mb-2 font-montserrat"
  ),
  seniorityItem: clsx(
    "flex justify-between items-center text-xs font-montserrat"
  ),
  seniorityLabel: clsx("text-raro-gray-600"),
  seniorityBadge: clsx(
    "inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium font-montserrat",
    "bg-raro-gray-100 text-raro-gray-800"
  ),
  technologyItem: clsx(
    "flex justify-between items-center text-xs font-montserrat"
  ),
  technologyLabel: clsx("text-raro-gray-600"),
  technologyBadge: clsx(
    "inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium font-montserrat",
    "bg-raro-gray-100 text-raro-gray-800"
  ),
  proposalButton: clsx(
    "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium font-montserrat",
    "transition-colors duration-200 hover:opacity-80"
  ),
};
